import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import NotificationSidebar from "./NotificationSidebar";
import api from "../api/axios";
import "../assets/styles/navbar.css";
import "../assets/styles/device-sessions.css";

const Navbar = ({
  sidebarOpen = false,
  sidebarCollapsed = false,
  onMenuClick,
  onCollapseClick,
  onStartTour,
}) => {
  const { user, logout } = useAuth();

  const [notificationOpen, setNotificationOpen] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);

const fetchUnreadCount = async () => {
  try {
    const res = await api.get(
      "/admin/notifications/unread-count",
      {
        headers: {
          "x-page-name": "Notifications",
          "x-action": "view",
        },
      }
    );

    setNotificationCount(
      Number(res.data?.count || 0)
    );
  } catch (error) {
    if (error.response?.status !== 403) {
      console.error(
        "Unread notification count failed:",
        error
      );
    }
  }
};

  useEffect(() => {
    fetchUnreadCount();

    const interval = setInterval(fetchUnreadCount, 30000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <header className="admin-navbar">
        <div className="admin-navbar-navigation">
          <button
            type="button"
            className="navbar-menu-button mobile-menu-button"
            aria-label={sidebarOpen ? "Close navigation menu" : "Open navigation menu"}
            aria-controls="admin-navigation"
            aria-expanded={sidebarOpen}
            onClick={onMenuClick}
          >
            <i className={`pi ${sidebarOpen ? "pi-times" : "pi-bars"}`} />
          </button>

          <button
            type="button"
            className="navbar-menu-button desktop-collapse-button"
            aria-label={sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
            aria-controls="admin-navigation"
            aria-expanded={!sidebarCollapsed}
            onClick={onCollapseClick}
          >
            <i className="pi pi-bars" />
          </button>

          <div className="admin-navbar-title" data-tour="workspace-title">
            <strong>Admin workspace</strong>
            <span>Wedding Stationery</span>
          </div>
        </div>

        {/* <Link to="/dashboard" className="admin-navbar-brand">
          <span className="brand-mark">WS</span>
          <span>Wedding Admin</span>
        </Link> */}

        <div className="admin-nav-links">
          <button
            type="button"
            className="navbar-guide-button"
            aria-label="Start admin panel guide"
            title="Start admin panel guide"
            data-tour="restart-guide"
            onClick={onStartTour}
          >
            <i className="pi pi-question-circle" />
            <span>Guide</span>
          </button>

          <button
            type="button"
            className="notification-bell"
            data-tour="notifications"
            aria-label="Open notifications"
            onClick={() => setNotificationOpen(true)}
          >
            <i className="pi pi-bell" />

            {notificationCount > 0 && (
              <span className="notification-count">
                {notificationCount > 99 ? "99+" : notificationCount}
              </span>
            )}
          </button>

          <NavLink
            to="/account"
            className="admin-profile"
            data-tour="admin-profile"
            title="My account"
            aria-label={`My account: ${user?.name || "Admin"}`}
          >
            {user?.image_url ? (
              <img
                src={user.image_url}
                alt={user.name}
                className="admin-avatar-image"
              />
            ) : (
              <div className="admin-avatar">
                {(user?.name || "A").charAt(0).toUpperCase()}
              </div>
            )}

            <div className="admin-profile-info">
              <span>{user?.name || "Admin"}</span>
              <small>{user?.email || "Administrator"}</small>
              <small>Administrator</small>
            </div>
          </NavLink>

          <button
            type="button"
            onClick={logout}
            className="ghost-action navbar-logout-button"
            aria-label="Sign out"
            title="Sign out"
          >
            <i className="pi pi-sign-out" />
          </button>
        </div>
      </header>

      <NotificationSidebar
        visible={notificationOpen}
        onHide={() => {
          setNotificationOpen(false);
          fetchUnreadCount();
        }}
        onUnreadChange={setNotificationCount}
      />
    </>
  );
};

export default Navbar;
